import { Menu } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'

export function SideMenu({
  items,
  mode = 'inline',
  selectedKeys: selectedKeysProp,
}) {
  const navigate = useNavigate()
  const location = useLocation()

  const selectedKeys = []
  const defaultOpenKeys = []

  if (selectedKeysProp) {
    selectedKeys.push(...selectedKeysProp)
  } else {
    for (let item of items) {
      if (location.pathname.split('?')[0].startsWith(item.key.split('?')[0])) {
        selectedKeys.push(item.key)
      }
      if (typeof item.children !== 'undefined') {
        for (let childItem of item.children) {
          if (
            location.pathname
              .split('?')[0]
              .startsWith(childItem?.key?.split('?')?.[0])
          ) {
            defaultOpenKeys.push(item.key)
            selectedKeys.push(childItem.key)
          }
        }
      }
    }
  }

  return (
    <Menu
      mode={mode}
      style={{ border: 0 }}
      triggerSubMenuAction="click"
      onClick={({ key }) => {
        if (key.startsWith('/')) {
          navigate(key)
        }
      }}
      items={items}
      defaultOpenKeys={defaultOpenKeys}
      selectedKeys={selectedKeys}
    />
  )
}
